<template>
  <div class="bg-white mobile-wrapper" :class="isSushi && 'montserrat-500'">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div class="col-12 banner-title">
            <span class="material-icons md-36" @click="goBack">keyboard_arrow_left</span>
            <span   :class="isSushi ? 'montserrat-700' :  'title-text'" @click="goBack">{{ $t('message.myAccount') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="justify-content-center">
      <div class="col-12 bg-white py-4">
        <form
          class="pt-4 mt-4 d-flex flex-wrap justify-content-center"
          @submit.prevent="submitForm"
        >
          <my-detail ref="myDetail" :edit-model="detailModel" />
          <cards :dbuser="dbuser" :isSushi="isSushi" />
          <div
            v-if="success"
            class="alert alert-primary p-4 mt-4 alert-color w-100"
            role="alert"
          >{{ $t('message.profileSavedSuccessfully') }}</div>
          <div
            v-if="hasError"
            class="alert alert-danger p-4 mt-4 alert-color w-100"
            role="alert"
          >{{ hasError }}</div>
          <div class="w-100" style="margin-top:4rem">
            <button
              :disabled="loading"
              type="submit"
              class="btn btn-lg btn-block shadow btn-primary d-flex justify-content-center align-items-center"
              :class="isSushi && 'background-sushi curved-5'"
              :style="mobileStyles.btn"
            >
              {{ $t('message.saveChanges') }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import MyDetail from "./MyDetail";
import cards from "./cardsMobile";
import { mapGetters, mapActions } from "vuex";
import { getDBUser } from "../../api/services/userService.js";
import shared from "../../sharedscripts/user/profile.js";
import common from "../../sharedscripts/Common/commonMobile";

export default {
  components: {
    MyDetail,
    cards
  },
  data() {
    return {
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: ""
      },
      dbuser: {},
      hasError: "",
      success: false,
      loading: false,
      Phone: "",
    };
  },
  computed: {
    ...mapGetters(["user", "hqDoc", "currentStoreDoc", "mobileStyles"]),
    isSushi() {
      return this.hqDoc && this.hqDoc.IsSushiHub;
    }
  },
  watch: {
    user() {
      let that = this;
      if (this.user) {
        getDBUser(this.user.id).onSnapshot(
          function(doc) {
            if (doc.exists) {
              that.dbuser = doc.data();
              that.initModel();
            }
          },
          function(reason) {
            that.insertErrorlog([
              reason.name,
              reason.toString(),
              that.$router.currentRoute.fullPath
            ]);
            that.redirectToErrorPage();
          }
        );
      }
    }
  },
  mounted() {
    let that = this;
    if (this.user) {
      getDBUser(this.user.id).onSnapshot(
        function(doc) {
          if (doc.exists) {
            that.dbuser = doc.data();
            that.initModel();
          }
        },
        function(reason) {
          that.insertErrorlog([
            reason.name,
            reason.toString(),
            that.$router.currentRoute.fullPath
          ]);
          that.redirectToErrorPage();
        }
      );
    }
  },
  methods: {
    ...mapActions(["insertErrorlog", "redirectToErrorPage"]),
    ...shared.methods,
    ...common.methods
  }
};
</script>
